<template>
  <BaseInnerLoading
    v-if="isLoading || isFetchingCurrentTenant"
  />
  <p
    v-else-if="!currentTenant?.hasBeepaidGoModule"
    class="text-error"
  >
    This merchant does not have Beepaid GO enabled
  </p>
  <p v-else-if="services?.length === 0" class="text-error">
    No services found
  </p>
  <div v-else>
    <ul class="space-y-6">
      <li v-for="service in services" :key="service.id">
        <DashboardLink
          :to="{
            name: 'servicePaymentCreate',
            params: { serviceId: service.id },
          }"
        >
          <div class="flex flex-col items-center">
            <div
              class="text-xl font-semibold text-background-fg/87"
            >
              {{ service.name }}
            </div>
            <div class="text-sm text-background-fg/70">
              {{ service.description }}
            </div>
            <div
              class="text-xl font-bold text-background-fg/87"
            >
              {{
                service.cost
                  ? formatToCurrencyString(service.cost)
                  : "-"
              }}
            </div>
          </div>
        </DashboardLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const { data: services, isLoading } = useServices()
const {
  currentTenant,
  isFetching: isFetchingCurrentTenant,
} = useCurrentTenant()
</script>
